import { render, staticRenderFns } from "./NewProgetto.vue?vue&type=template&id=0770f00f&"
import script from "./NewProgetto.vue?vue&type=script&lang=js&"
export * from "./NewProgetto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports